<ng-container *transloco="let t; read: 'configuration-concept-topics-component'"
  ><app-configuration-item-editor
    [configuration]="configuration()"
    [configurationLayers]="configurationLayers()"
    [itemTypeTitle]="itemType"
    [canSearchBy]="true"
    searchPlaceholder="{{ t('search-placeholder') }}"
    queryPropName="samples"
    syntaxHelpLink="https://semantria-docs.lexalytics.com/docs/user-categories-concept-topics"
    [loadItemsApi]="loadItems"
    [createItemApi]="createItem"
    [saveItemApi]="saveItem"
    [deleteItemApi]="deleteItem"
    [deleteAllItemsApi]="deleteAllItems"
    [evaluateItemApi]="evaluateItem"
    [getEvaluationConfigApi]="getEvaluationConfig"
    [getHighlightTextString]="getHighlightText"
    [getEvaluationItemHighlightValue]="getItemHighlightValue"
    [getEvaluationItemByClonedFrom]="getItemByClonedFrom"
    [deleteEvaluationConfigApi]="deleteEvaluationConfig"
    [selectedItemId]="selectedItemId"
    [selectedItemName]="selectedItemName"
    [rowExtraTemplate]="rowData"
    [editorTemplate]="editorData"
    [itemsEditable]="editable"
    [testingEnabled]="canTestItem()"
    [taxonomyItemUsage]="taxonomyItemUsage?.concept_topics"
    fragment="concept_topics"
    (selectedItemChange)="onItemEditing($event)"
    (itemsLoaded)="onItemsLoaded($event)"
    (saving)="onItemSaving($event)"
    (itemsDeleted)="onItemsDeleted($event)"
    (allItemsDeleted)="onAllItemsDeleted($event)"
    (itemAdded)="onItemAdded($event)"
    (itemUpdated)="onItemUpdated($event)"
  ></app-configuration-item-editor>

  <ng-template #rowData let-item>
    <div class="configuration-concept-topic__weight-row">
      {{ item.weight | number: '1.1-1' }}
    </div>
  </ng-template>

  <ng-template #editorData let-item>
    <div class="configuration-concept-topic__weight-editor-wrapper">
      <div class="configuration-concept-topic__weight-editor-slider">
        <div>{{ t('boost-value') }}</div>

        <xi-slider
          color="CX"
          [disabled]="isSaving || !canEditItem()"
          [min]="sliderLimits.min"
          [max]="sliderLimits.max"
          [increment]="1e-1"
          [(value)]="item.weight"
          (onSliderChange)="onWeightChanged($event.detail.value)"
        ></xi-slider>
      </div>

      @if (item.weight === 0) {
        <div class="configuration-concept-topic__weight-editor-warning">
          {{ t('boost-warning') }}
        </div>
      }
    </div>
  </ng-template>
</ng-container>
